import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  loginTitle: 'Autentificare administrator',
  loginLead: 'Intrare în administrarea AKIS pentru conturile de administrator de sistem.',
  username: 'Utilizator',
  password: 'Parola',
  showPassword: 'Arată parola',
  hidePassword: 'Ascunde parola',
  signIn: 'Autentifică-te',
  signingIn: 'Se verifică…',
  loginFailed: 'Autentificarea nu a reușit.',
  lockedUntil: 'Blocat până la {{when}}.',
  usernameRequired: 'Scrieți numele de utilizator.',
  passwordRequired: 'Scrieți parola.',
  passwordTitle: 'Schimbarea parolei',
  passwordLead:
    'Alegeți o parolă nouă înainte de a continua. Parola temporară primită nu mai poate fi folosită după schimbare.',
  currentPassword: 'Parola curentă',
  newPassword: 'Parola nouă',
  confirmation: 'Confirmați parola nouă',
  passwordHint: 'Cel puțin 12 caractere; diferită de numele de utilizator.',
  changePassword: 'Schimbă parola',
  changingPassword: 'Se salvează…',
  passwordChanged: 'Parola a fost schimbată.',
  toCabinet: 'Mergi la cabinet',
  changeFailed: 'Parola nu a putut fi schimbată.',
  currentRequired: 'Scrieți parola curentă.',
  passwordTooShort: 'Parola trebuie să aibă cel puțin 12 caractere.',
  passwordTooLong:
    'Parola este prea lungă: cel mult 72 de octeți (o literă cu diacritice ocupă doi).',
  passwordEqualsUsername: 'Parola nu poate fi identică cu numele de utilizator.',
  passwordUnchanged: 'Parola nouă trebuie să difere de cea curentă.',
  confirmationMismatch: 'Confirmarea nu este identică cu parola nouă.',
} as const;

const en = {
  loginTitle: 'Administrator sign-in',
  loginLead: 'Entry to the AKIS administration for system administrator accounts.',
  username: 'Username',
  password: 'Password',
  showPassword: 'Show the password',
  hidePassword: 'Hide the password',
  signIn: 'Sign in',
  signingIn: 'Checking…',
  loginFailed: 'The sign-in failed.',
  lockedUntil: 'Locked until {{when}}.',
  usernameRequired: 'Write the username.',
  passwordRequired: 'Write the password.',
  passwordTitle: 'Change the password',
  passwordLead:
    'Choose a new password before going on. The temporary password you received no longer works once changed.',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmation: 'Confirm the new password',
  passwordHint: 'At least 12 characters; not the username.',
  changePassword: 'Change the password',
  changingPassword: 'Saving…',
  passwordChanged: 'The password has been changed.',
  toCabinet: 'Go to your personal account',
  changeFailed: 'The password could not be changed.',
  currentRequired: 'Write the current password.',
  passwordTooShort: 'The password needs at least 12 characters.',
  passwordTooLong:
    'The password is too long: at most 72 bytes (a letter with diacritics takes two).',
  passwordEqualsUsername: 'The password cannot be the username.',
  passwordUnchanged: 'The new password has to differ from the current one.',
  confirmationMismatch: 'The confirmation does not match the new password.',
} satisfies Translation<keyof typeof ro>;

export const adminAuth = { ro, en } satisfies Dictionary;

export type AdminAuthKey = keyof typeof ro;
